import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ValidateSessionResponse } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb';
import { ValidateUserSessionResponse } from '@spilca/accounting_ts/v1/auth_private/auth_service_pb';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import { COOKIE_KEYS, getCookie, QUERY_KEYS } from '@monorepo/helpers';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const REFETCH_INTERVAL = 60 * 1000;

type TResponse =
  | ValidateSessionResponse.AsObject
  | ValidateUserSessionResponse.AsObject;

const useIsAuthenticated = (): UseQueryResult<
  TResponse,
  TGRPCPromiseReject
> => {
  const request = useGetRequest(REQUEST_TYPES.VALIDATE_SESSION);

  const requestPromise = async () => {
    const sessionToken = getCookie(COOKIE_KEYS.SESSION_TOKEN);
    console.log(
      '[useIsAuthenticated] queryFn вызван, sessionToken:',
      sessionToken
    );

    // Если токена нет - выбрасываем ошибку, чтобы кеш инвалидировался
    if (!sessionToken) {
      console.log('[useIsAuthenticated] Нет токена, выбрасываю ошибку');
      return { userId: null } as TResponse;
    }

    const response = await request(sessionToken);
    console.log('[useIsAuthenticated] Ответ сервера:', response);

    // Нормализуем ответ - если userId пустой, возвращаем объект с null
    // Это гарантирует обновление кеша при изменении состояния сессии
    if (!response?.userId) {
      console.log(
        '[useIsAuthenticated] userId пустой, возвращаю {userId: null}'
      );
      return { userId: null } as TResponse;
    }

    console.log('[useIsAuthenticated] userId найден:', response.userId);
    return response;
  };

  return useQuery({
    queryKey: [QUERY_KEYS.CHECK_SESSION],
    queryFn: requestPromise,
    refetchInterval: getCookie(COOKIE_KEYS.SESSION_TOKEN)
      ? REFETCH_INTERVAL
      : false,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 0
  });
};

export default useIsAuthenticated;
